import React from 'react'
import Link from 'gatsby-link'
//import App from 'grommet/components/App'
//import Image from 'grommet/components/Image'
import Box from 'grommet/components/Box'
import Card from 'grommet/components/Card'
import Heading from 'grommet/components/Heading'
import Paragraph from 'grommet/components/Paragraph'
import Section from 'grommet/components/Section'



//import Person from "../img/person.jpg"

const IndexPage = () => (
  <Box margin={{horizontal: "none", vertical: "large"}} pad={{horizontal: "medium", vertical: "none"}}>
    <Box margin={{horizontal: "none", vertical: "large"}}  align="center" 
         direction="row">

      <Box pad="medium">
        <Box align='start'>
          <Heading tag='h1'>
            <a href="https://twitter.com/kainio">@kainio</a> est un alias virtuel utilisé comme un canal de publication<br/>
            par <strong class="real_name" style={{color: "rgb(140, 80, 255)"}}>Soufiane El Kassib</strong>
          </Heading>
          <Paragraph size="large">
            kainio est un concepteur, développeur des solutions pour des problèmes bien définis.
          </Paragraph>
        </Box>
        <Section id="about">
          <Heading tag="h2">
            #define Je "kainio"
          </Heading>
          <Paragraph>
            Je propose des solutions techniques modernes, en utilisant les médias traditionnels comme des canaux de distribution des informations pour atteindre une audience large et variée, afin d'offrir une valeur ajoutée à la vie sociale, que ce soit par la création d’une plateforme commercial locale ou d’un système de publication pour les organisations, proposant ainsi des solutions optimales pour des problèmes bien posés.
          </Paragraph>
        </Section>
        
        <Section>
          <Heading tag="h3">
            Technologies et méthodologie de travail
          </Heading>
          <Paragraph>
            Le choix du langage de programmation dépend des spécificités de chaque projet, ainsi je peux traiter et distribuer les données suivant plusieurs formats, tout en les manipulant par l'utilisation des scripts comme le <strong>JavaScript</strong> et ses variantes, et grâce à des outils et frameworks modernes coté front-end, j'arrive à bien structurer les données collectées venant des divers sources et bases de données relationnelles, transmises à travers des <strong>API</strong> internes ou externes fournis par une partie tierce, tout cela, suivant une méthodologie agile où les modifications sont fréquentes lors du processus de développement.
          </Paragraph>
        </Section>
        <Box align='start'>
          <Heading tag='h2'>
            La conception comme service
          </Heading>
          <Paragraph size="large">
            Commerce électronique, publication digitale et traditionnelle, et sans oublier un espace de discussion et de partage.
          </Paragraph>
        </Box>
        <Section>
          <Heading tag="h3">
            Centres d'intérêt
          </Heading>
          <Paragraph>
            Je suis intéressé par les sujets liés au développement web et logiciel ainsi que la conception d’expériences utilisateurs destinées à une large audience.
          </Paragraph>
        </Section>
        
        <Section id="work">
          <Heading tag="h3">
            Innover dans le domaine commercial et la publication digitales
          </Heading>
          <Paragraph>
            Je travaille actuellement sur des solutions concernant le domaine commercial et la publication, dans le but de permettre au commerce local de s'étendre sur internet, aux organisations de publier un contenu ciblé via un site web responsive propulsé par un système de gestion de contenu, ce dernier sera choisis selon la complexité des informations à traiter, proposant ainsi une solution flexible qui s'adapte aux besoins de chaque projet.
          </Paragraph>
        </Section>
        
        <Section>
          <Box align='start'>
            <Heading tag='h2'>
              <a href="https://twitter.com/creatima">@creatima</a> est un guide d'apprentissage du développement web avec <strong>Rails</strong>
            </Heading>
            <Paragraph size="large">
              Pour les impatients qui veulent exécuter et accélérer le développement de leur idée innovante.
            </Paragraph>
          </Box>
          <Heading tag="h3">
            (Prochainement) Lancement de creatima
          </Heading>
          <Paragraph>
            Pour permettre aux utilisateurs de parler entre eux sur divers sujets, je compte publier sur <a href="http://twitter.com/creatima">@creatima</a> un guide sur le développement web avec le framework ruby on rails qui servira comme un résumé de mon parcours d'apprentissage de cet outil de conception, orienté vers le développement des applications web avec le langage ruby, dans le lequel, je créerai une documentation détaillée en illustrant le processus de création d'un prototype, qui servira d'un MVP (Minimum Viable Product) d'une application open source de messagerie et va être par la suite finalisée puis déployée en ligne.
          </Paragraph>
        </Section>
      </Box>
    </Box>
    <Box>
      <Paragraph>
        Vous pouvez me suivre sur les médias sociaux <a href="https://twitter.com/kainio">twitter</a>, <a href="https://github.com/kainio">github</a> et <a href="https://mastodon.social/@soufiane">mastodon</a>
      </Paragraph>
    </Box>
  </Box>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js